// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* purgecss start ignore */

/* purgecss end ignore */`, "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,0BAAA;;AAAA,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
